<template>
    <div v-if="priceContent" class="info-box">
        <template v-for="item in priceContent" :key="item.title" > 
            <template v-if="!!item.content">
                <div v-if="item.type && item.type === 'link'" class="card-content" :class="{'extra-width': item.extraWidth}">
                    <p class="card-title">{{item.title}}</p>
                    <a class="url" v-if="typeof(item.content) == 'string' " :href="item.content" target="_blank">External link</a>
                </div>
                <div v-else-if="item.type && item.type === 'linkList' && item.content.length" class="card-content full">
                    <p class="card-title">{{item.title}}</p>
                    <template v-for="link in item.content" :key="link">
                        <a v-if="link.startsWith('https://')" class="url linkItem text-ellipsis overflow-hidden" :href="link.toString()" target="_blank">{{link}}</a>
                        <a v-else class="url linkItem text-ellipsis overflow-hidden" :href="`https://${link.toString()}`" target="_blank">{{link}}</a>
                    </template>
                </div>
                <div v-else-if="item.type && item.type === 'list' && item.content.length" class="card-content" :class="{'extra-width': item.extraWidth}">
                    <p class="card-title">{{item.title}}</p>
                    <p v-for="itemInList in item.content" :key="itemInList">{{ itemInList }}</p>
                </div>
                <div v-else-if="item.type && item.type === 'boolean'" class="card-content" :class="{'extra-width': item.extraWidth}">
                    <span class="card-title">{{item.title}}</span>
                    <img v-if="item.content" src="@/assets/icons/checked.png" alt="item.title" />
                    <img v-else src="@/assets/icons/remove.png" alt="item.title" />
                </div>
                <div v-else-if="item.content === 'RESEARCH PROJECT'" class="card-content" :class="{'extra-width': item.extraWidth}">
                    <p class="card-title">{{item.title}}</p>
                    External Opportunity
                </div>
                <div v-else class="card-content" :class="{'extra-width': item.extraWidth}">
                    <p class="card-title">{{item.title}}</p>
                    {{item.content}} 
                </div>
            </template>
        </template>
    </div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue';
import { PriceContentType } from '@/models/technologyAssetInterface';

defineProps<{
    priceContent: Array<PriceContentType>,
}>();

</script>
<style lang="scss" scoped>
.info-box{
    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;
    .card-content {
        width: 25%; 
        flex-shrink: 0; 
        border-left: 1px solid #ddd;
        text-align: initial;
        padding: 0 1.5rem 0.5rem 1rem;  
        font-size: 0.85rem; 
        color: $font-color-light; 
        font-weight: 500;
        overflow: auto;
        text-transform: uppercase;
        overflow: visible;
        &.extra-width {
            width: 50%;
        }
        &.full {
            width: 100%;
        }
        .url {
            text-decoration: underline;
            cursor: pointer;
            text-transform: none;
            &.linkItem {
                display: block;
                // max-width: 200px;

            }
        }
        input[type=text] {
            background-color: $grey-modal!important;
            &:focus {
                border: 2px solid $blue-bg-text;
            }
        }

    }
}
.card-title {
    font-size: 0.9rem;
    color: $font-color-super-light;
    font-weight: 300;
    text-transform: none;
    position: relative;
    span {
        font-size: 0.7rem;
        color: #999;
    }
    &::after{
        content: "";
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #eeeeee;
        border: 1px solid #dddddd;
        position: absolute;
        left: -22px;
        top: 4px;
    }
    
}

.selected-results span {
    text-transform: none;
    color: white;
    background-color: $blue-bg-text;
    font-weight: 300;
    svg {
        stroke: white;
    }
}
img {
    display: inline-block;
    margin-left: 10px;
    width: 16px;
    opacity: 0.8;
}
    
</style>
